// A request the gateway could not DELIVER. The gateway answers
// `V1.ECONNREFUSED` when the service behind it was not listening at all — a
// deploy, or a dev restart — so nothing was received, nothing was done, and
// sending it once more is safe for any method, POST included. Giving up
// inside that window turned every restart into a "Could not save that just
// now" banner on whatever the member was doing, and a boot is a few seconds.
//
// Deliberately narrow: a reset, a timeout, a 502 or a 504 mean the request
// MAY have reached the service and been acted on, and re-sending a POST could
// double the work. Those still fail straight through.
//
// Its own module so the rule can be tested without the client, which the
// unit harness mocks wholesale.
export const AWAY_RETRY_MS = 3000;
export const isNeverDelivered = (status, code) =>
  status === 500 && /(^|\.)ECONNREFUSED$/.test(String(code || ''));
